function getBaseUrl () {
  if (
    process.env.NODE_ENV === 'production'
  ) {
    const domain = window.location.host.replace('-pc', '')
    const baseUrl = domain.replace(/hpay-charge/g, 'hpay-charge-api')
    const pro = window.location.protocol
    return `${pro}//${baseUrl}`
  } else {
    return '/api'
  }
}
export const apiURL = getBaseUrl()
// export const apiURL = '/api'
